export const colours = {
  primary: {
    '00': '#F0F4FF',
    '50': '#DDE8FF',
    '100': '#D0D5FC',
    '200': '#C5D8FF',
    '300': '#727FF2',
    '500': '#1929D6',
    '700': '#0C169A',
    '800': '#0C008a',
    '900': '#040966',
  },
  grey: {
    '00': '#FFFFFF',
    '50': '#F1F2F3',
    '100': '#E4E4E7',
    '200': '#C8C9D0',
    '400': '#9293A0',
    '600': '#5F606D',
    '700': '#616371',
    '800': '#2F3037',
    '900': '#282B3A',
    '1000': '#0C0C0E',
  },
  success: {
    '100': '#D2FAD1',
    '300': '#74E489',
    '500': '#1EA853',
    '700': '#0F784C',
    '900': '#055040',
  },
  error: {
    '100': '#FDE3D7',
    '300': '#F79788',
    '500': '#E73A41',
    '700': '#A61D3B',
    '900': '#6E0B32',
  },
  warning: {
    '100': '#FDF4CE',
    '300': '#F8D36E',
    '500': '#E8A011',
    '700': '#A76708',
    '900': '#6F3C03',
  },
  purple: {
    '100': '#EACDFB',
    '300': '#AF69E7',
    '500': '#5A11B0',
    '700': '#33087E',
    '900': '#190354',
  },
  navy: {
    '100': '#C6D0F7',
    '300': '#546BD2',
    '500': '#00106A',
    '700': '#00094C',
    '900': '#000432',
  },
  blue: {
    '100': '#CFECFD',
    '300': '#70B8F3',
    '500': '#176FD7',
    '700': '#0B409A',
    '900': '#041F67',
  },
  teal: {
    '100': '#D2FAEC',
    '300': '#76E1CE',
    '500': '#219C9C',
    '700': '#105F70',
    '900': '#06334A',
  },
  yellow: {
    '100': '#FFF4D1',
    '300': '#FFD376',
    '500': '#FFA41B',
    '700': '#B7650D',
    '900': '#7A3805',
  },
  orange: {
    '100': '#FEEAD5',
    '300': '#F9AF82',
    '500': '#EC5C31',
    '700': '#A92518',
    '900': '#71090F',
  },
  magenta: {
    '100': '#FCD2D1',
    '300': '#F07488',
    '500': '#CD1D5C',
    '700': '#930E58',
    '900': '#62054B',
  },
  brown: {
    '100': '#F7ECDD',
    '300': '#D2AE90',
    '500': '#6B4533',
    '700': '#4D2319',
    '900': '#330C09',
  },
  foYellow: {
    '100': '#FDDC86',
    '300': '#FDD05E',
    '500': '#FCC22D',
    '700': '#FBB80E',
    '900': '#DD9F03',
  },
};
